import {NotificationWindowDetails} from "../../pro-report/shared/notification-window";
import {ProReportConstants} from "../../pro-report/shared/pro-report-constants";
import {ConfirmationDialogComponent} from "./confirmation-dialog.component";
import {Injectable, Injector} from "@angular/core";
import {Notification_Window_TOKEN} from "../../pro-report/shared/injection-token";
import {OverlayOptions, OverlayUtils} from "../../utils/overlay-utils";
import {Router} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogOpener {

  constructor(public overlayUtils: OverlayUtils,
              private router: Router) {
  }

  /**
   * Open Confirmation dialog when leaving dirty report.
   * Navigate by params on ok click
   * @param url url to open after success
   * @param extras extras for url
   */
  public openBackToMainConfirmDialog(url: string, extras: any): void {
    const nwd = new NotificationWindowDetails();
    nwd.text = ProReportConstants.backToMainWarning;
    nwd.header = ProReportConstants.backToMainHeader;
    nwd.headerClass = 'font-size-245'
    nwd.buttonsReverse = true;
    this.overlayUtils.createOverLay(ConfirmationDialogComponent, Injector.create({
      providers: [{provide: Notification_Window_TOKEN, useValue: nwd}]
    }), null).closeObs$.subscribe({
      next: (res: boolean) => {
        if (res === true) {
          this.router.navigateByUrl(url, extras);
        }
      }
    });
  }

  public openConfirmDialog(): OverlayOptions {
    const nwd = new NotificationWindowDetails();
    nwd.text = ProReportConstants.backToMainWarning;
    nwd.header = ProReportConstants.backToMainHeader;
    nwd.headerClass = 'font-size-245'
    nwd.buttonsReverse = true;
    return this.overlayUtils.createOverLay(ConfirmationDialogComponent, Injector.create({
      providers: [{provide: Notification_Window_TOKEN, useValue: nwd}]
    }), null);
  }
}
